import {
  RowDataObject,
  RowDataReducerState,
  RowDataReducerAction,
  RowData,
} from "../../../../../types";

export const handlePOConfigurationGroupAccountsGLStoreOptionsOnStoresChange = (
  inputValue: RowDataObject[],
  selectedTabSectionKey: string,
  rowDataReducerState: RowDataReducerState,
  dispatch: React.Dispatch<RowDataReducerAction>,
): void => {
  if (!inputValue || !selectedTabSectionKey) return;

  const storeFieldKey = "store_id";
  const targetPropertyKey = "ref_store";
  const dependentFieldKeys = ["ref_store", "ref_company", "ref_account"];

  const availableSelectedStores = inputValue
    .filter((item) => item[storeFieldKey] !== "")
    .map((item) => item[storeFieldKey]);

  const currentStoreSelection = (
    rowDataReducerState.rowData[selectedTabSectionKey] as RowData
  )[targetPropertyKey] as string;

  const isCurrentStoreInvalid = !availableSelectedStores.includes(
    currentStoreSelection,
  );

  if (isCurrentStoreInvalid) {
    dependentFieldKeys.forEach((field) => {
      dispatch({
        type: "UPDATE_FIELD",
        payload: {
          propertyKey: field,
          newFieldValue: "",
          selectedTabSectionKey,
        },
      });
    });
  }
};
